// Components
import {Components} from "@webtech/webtech-ui-react/build/webtech-ui";

// Styles
import "./Lists.component.scss";

// Constants
import {Link, RouteComponentProps, withRouter} from "react-router-dom";
import React, {Component} from "react";
import {SubsidiaryUtils} from "../../../../utils/Subsidiary/SubsidiaryUtils";
import {ActionCreator} from "../../../../actions/actions";
import {Flags} from "../../../../utils/Flags/Flags";
import {Subsidiary} from "../../../halls/types/subsidiaries";
import {connect} from "react-redux";
import {mailingStoreSelectors} from "../../store/store";
import {MailingActionCreators} from "../../actions/actionCreators";
import {checkPermission} from "../../../../utils/Authorization/authorization";
import Paginator from "../../../../utils/Paginator/Paginator.component";

const MAILING_PER_PAGE = 21;
const INITIAL_PAGE = 0;

export interface ListsProps extends RouteComponentProps {
    mailingLists: any;
    mailingListsLoading: boolean;
    getMailingLists: ActionCreator;
    getSubsidiaries: ActionCreator;
    activateMailingList: ActionCreator;
    deactivateMailingList: ActionCreator;
    subsidiariesList: Subsidiary[];
    subsidiariesLoading: boolean;
}

export interface ListsState {
    searchText: string;
    subsidiaryFilterValue: string[];
    statusFilterValue: string;
    currentPage: number;
}

class Lists extends Component<ListsProps, ListsState> {
    subsidiaryFilter: React.RefObject<Components.SelectMenu>;
    canEdit: boolean;

    constructor(props) {
        super(props);

        this.props.getSubsidiaries();
        this.subsidiaryFilter = React.createRef();

        this.state = {
            searchText: "",
            subsidiaryFilterValue: [],
            statusFilterValue: "1",
            currentPage: INITIAL_PAGE
        };

        this.getMailingLists()

        this.canEdit = checkPermission("edit_mailing_list");
    }

    getMailingLists() {
        this.props.getMailingLists({
            page: this.state.currentPage,
            top: MAILING_PER_PAGE,
            search: this.state.searchText,
            subsidiaries: this.state.subsidiaryFilterValue,
            status: this.state.statusFilterValue
        });
    }

    renderMailingLists = () => {
        if (this.props.mailingLists.results && this.props.mailingLists.results.length === 0) {
            return (
                <div className="mailing-list-no-mailing">
                    No Mailing Lists records to display. Please select different
                    values to try again.
                </div>
            );
        }
        return (
            this.props.mailingLists.results &&
            this.props.mailingLists.results.map((mailing, index) => {
                const sub = this.props.subsidiariesList.find(
                    subsidiary => subsidiary.id == mailing.subsidiary
                );

                return (
                    <div className="mailing-card" key={index}>
                        <div className="mailing-card-body">
                            <div className="row mailing-header">
                                <h2>{mailing.name}</h2>
                                {this.canEdit && (
                                    <Link
                                        to={`/admin/mailing/edit/${mailing.id}`}
                                        className="icon-edit tooltip-icon">
                                        <span className="tooltip-text">Edit</span>
                                        <i className="icon-pencil-alt-light"></i>
                                    </Link>)}
                            </div>

                            <label>Subsidiary</label>
                            {sub && (
                                <div className="subsidiary">
                                    {SubsidiaryUtils.subsidiaryIcon(sub)}
                                    {sub.description}
                                </div>
                            )}
                            {sub == undefined && "-"}
                        </div>

                        <div className="mailing-card-footer">
                            <a
                                className="mailing-card-link"
                                href={`/admin/mailing/detail/${mailing.id}/`}
                            >
                                Details
                            </a>

                            {this.canEdit && (
                                <div className="mailing-card-status">
                                    <span>
                                        {mailing.active ? "Active" : "Inactive"}
                                    </span>
                                    <Components.Switch
                                        onClick={() =>
                                            mailing.active
                                                ? this.props.deactivateMailingList(
                                                    mailing
                                                )
                                                : this.props.activateMailingList(
                                                    mailing
                                                )
                                        }
                                        on={mailing.active}
                                        enabled={true}/>
                                </div>
                            )}
                        </div>
                    </div>
                )
            })
        );
    };

    applyFilters = (value, field) => {
        let updatedState = {...this.state};
        updatedState[field] = value
        this.setState({
            ...updatedState,
            currentPage: INITIAL_PAGE
        }, this.getMailingLists)
    }

    pageChange = newPage => {
        this.setState({currentPage: newPage - 1}, this.getMailingLists);
    };

    onClearFilters = () => {
        this.subsidiaryFilter.current.selectItem([]);
        this.subsidiaryFilter.current.setDisplayString("Choose Subsidiary");

        this.setState({
            searchText: "",
            subsidiaryFilterValue: [],
            statusFilterValue: "1"
        });
    };

    render() {
        const isLoading =
            this.props.subsidiariesLoading || this.props.mailingListsLoading;
        const mailingStatus = [
            {
                value: "",
                label: "All"
            },
            {
                value: 1,
                label: "Active"
            },
            {
                value: 0,
                label: "Inactive"
            }
        ];

        return (
            <div id="MailingListsPage" className="content">
                <div className="container">
                    <div className="row">
                        <div className="col-6">
                            <h2>Mailing Lists</h2>
                        </div>
                        <div className="col-6 center-vertical buttons-col">
                            {this.canEdit && (
                                <Link
                                    to={`/admin/mailing/new`}
                                    className="new-mailing red-btn"
                                >
                                    <span>New Mailing List</span>
                                </Link>)}
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12">
                            <div className="mailing-filters">
                                <div id="MailingPageFiltersBox">
                                    <div className="row">
                                        {this.props.subsidiariesLoading ? (
                                            <div className="mailing-list-loading">
                                                <Components.LoadingRipple
                                                    width={"75px"}
                                                    height={"75px"}
                                                />
                                            </div>
                                        ) : (
                                            <div className="adjustable-filters">
                                                <div className="mailing-filter">
                                                    <label className="label">
                                                        Search
                                                    </label>
                                                    <input
                                                        className="input"
                                                        onChange={event =>
                                                            this.applyFilters(event.target.value, 'searchText')}
                                                        value={
                                                            this.state
                                                                .searchText
                                                        }
                                                        placeholder="Text"
                                                    />
                                                </div>

                                                <div className="mailing-filter">
                                                    <label className="label">
                                                        Subsidiaries
                                                    </label>
                                                    <Components.SelectMenu
                                                        key={`${this.state.subsidiaryFilterValue}`}
                                                        ref={this.subsidiaryFilter}
                                                        noValueLabel="Choose Subsidiary"
                                                        multipleSelection
                                                        items={
                                                            this.props
                                                                .subsidiariesList &&
                                                            this.props
                                                                .subsidiariesList
                                                                .length > 0
                                                                ? SubsidiaryUtils.subsidiarySelectItems(
                                                                    this.props
                                                                        .subsidiariesList
                                                                )
                                                                : []
                                                        }
                                                        onChange={event =>
                                                            this.applyFilters(event, 'subsidiaryFilterValue')}
                                                        value={this.state.subsidiaryFilterValue}
                                                    />
                                                </div>

                                                <div className="adjustable-filters">
                                                    <div className="mailing-filter">
                                                        <label className="label">
                                                            Status
                                                        </label>
                                                        <Components.CheckboxGroup
                                                            key={this.state.statusFilterValue}
                                                            items={mailingStatus}
                                                            selected={this.state.statusFilterValue}
                                                            onChange={event =>
                                                                this.applyFilters(event, 'statusFilterValue')}
                                                        />
                                                    </div>
                                                </div>
                                                <div>
                                                    <button
                                                        className="clear-filters-btn"
                                                        onClick={this.onClearFilters}
                                                    >
                                                        Clear All Filters
                                                    </button>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="mailing-list">
                        {isLoading ? (
                            <div className="mailing-lists-loading">
                                <Components.LoadingRipple
                                    width={"100px"}
                                    height={"100px"}
                                />
                            </div>
                        ) : (
                            <div className="mailing row">
                                {this.renderMailingLists()}
                            </div>
                        )}
                    </div>
                </div>
                {!isLoading && (
                    <div className="row mailing-pagination container">
                        <div className="col-6 center-vertical paginator">
                            {this.props.mailingLists &&
                                this.props.mailingLists.count > 0 && (
                                    <Paginator
                                        currentPage={this.state.currentPage + 1}
                                        totalPages={Math.ceil(
                                            this.props.mailingLists.count /
                                            MAILING_PER_PAGE
                                        )}
                                        onPageChange={this.pageChange}
                                    />
                                )}
                        </div>
                    </div>
                )}
            </div>
        )
    }
}

const mapStateToProps = state => ({
    mailingLists: mailingStoreSelectors.mailingLists(state),
    mailingListsLoading: mailingStoreSelectors.mailingListsLoading(state),
    subsidiariesList: mailingStoreSelectors.subsidiaries(state),
    subsidiariesLoading: mailingStoreSelectors.subsidiariesLoading(state)
});

const mapDispatchToProps = {
    getMailingLists: MailingActionCreators.getMailingLists,
    getSubsidiaries: MailingActionCreators.getSubsidiaries,
    activateMailingList: MailingActionCreators.activateMailingList,
    deactivateMailingList: MailingActionCreators.deactivateMailingList
};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Lists));
